module.exports = __webpack_public_path__ + "img/linkedin.941c6474.png";